/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import * as React from 'react';
import { useForm } from 'react-hook-form';
import { signUp_DLXAsync } from '../../actions/DataActionExtension.g';
import { IUnsubscribeNewsletterViewProps } from './unsubscribe-newsletter';

const UnsubscribeNewsletterView: React.FC<IUnsubscribeNewsletterViewProps> = props => {
    type Inputs = {
        email: string;
    };
    // const { register, handleSubmit, watch, errors } = useForm<Inputs>();
    const { register, handleSubmit, errors } = useForm<Inputs>();
    // const marketingChoice: boolean = watch('marketing');
    const [loading, setLoading] = React.useState(false);
    const [disabled_state, setDisabled] = React.useState(false);
    const { yourEmailAddressText, unsubscribeRequestAccepted, unsubscribeRequestError, unsubscribeBtnText } = props.resources;

    let message = unsubscribeRequestAccepted;
    // const channelId: number = props.context.request.apiSettings.channelId;
    const [unsubscribeMessage, setUnsubscribeMessage] = React.useState({
        state: false,
        message: '',
        class: ''
    });

    const source: string = 'Unsubscribe Transactional';

    const _unsubscribe = async (data: Inputs) => {
        setDisabled(true);
        setLoading(true);
        signUp_DLXAsync(
            { callerContext: props.context?.actionContext },
            '',
            '',
            data.email,
            '',
            false,
            false,
            false,
            false,
            '',
            '',
            '',
            source,
            ''
        )
            .then(result => {
                if (result.Error !== '') {
                    throw new Error(result.Error);
                }
                message = unsubscribeRequestAccepted;
                setUnsubscribeMessage({
                    state: true,
                    message: message,
                    class: 'success'
                });
                setLoading(false);
            })
            .catch(err => {
                message = unsubscribeRequestError;
                setUnsubscribeMessage({
                    state: true,
                    message: message,
                    class: 'error'
                });
                setLoading(false);
            });
    };

    return (
        <div className={props.className} id={props.id} {...props.renderModuleAttributes(props)}>
            {props.paragraph}
            {unsubscribeMessage.state === false ? (
                <form onSubmit={handleSubmit(_unsubscribe)}>
                    <div className={'email_row row'}>
                        <div aria-invalid={errors.email ? 'true' : 'false'}>
                            <input
                                name='email'
                                type='email'
                                ref={register({ required: true })}
                                placeholder={yourEmailAddressText}
                                maxLength={320}
                            />
                            <button type='submit' disabled={disabled_state} className={`status__${unsubscribeMessage.class}`}>
                                {loading ? <div className={'loading'} /> : <span>{unsubscribeBtnText}</span>}
                            </button>
                        </div>
                    </div>
                </form>
            ) : (
                <div className={`msc-alert msc-alert-${unsubscribeMessage.class}`} role='alert'>
                    {unsubscribeMessage.message}
                </div>
            )}
            {props.secondaryParagraph}
        </div>
    );
};

export default UnsubscribeNewsletterView;
